export default class NumberAbbreviator {
  static format(number) {
    let formatted = number + '';
    if (number < 1000) {
      // if decimal places present
      if (NumberAbbreviator.countDecimals(formatted) > 3) {
        formatted = Math.round(number * 100) / 100;
      }
    }
    else if (number < 1000000) {
      number = number / 1000;
      formatted = Math.round(number * 100) / 100;
      formatted = formatted + 'K';
    } else if (number < 1000000000) {
      number = number / 1000000;
      formatted = Math.round(number * 100) / 100;
      formatted = formatted + 'M';
    } else if (number < 1000000000000) {
      number = number / 1000000000;
      formatted = Math.round(number * 100) / 100;
      formatted = formatted + 'B';
    } else if (number < 1000000000000000) {
      number = number / 1000000000000;
      formatted = Math.round(number * 100) / 100;
      formatted = formatted + 'T';
    }
    return formatted;
  }

  static countDecimals(value) {
    if (value.indexOf(".") == -1) return 0;
    return value.toString().split(".")[1].length || 0;
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/numberAbbreviator.js